<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.006 17.006">
  <path
    fill="none"
    stroke="#fff"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    d="M16.006 16.006 4.766 4.766"
  />
  <path
    fill="none"
    stroke="#2ca9bc"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    d="m1.966 1.026 3.68.73a1 1 0 0 1 .59 1.54l-2.94 2.94a1 1 0 0 1-1.54-.59l-.73-3.68a.77.77 0 0 1 .94-.94Z"
  />
</svg>
